import { IAuditLog, IEntity, IEntityDetails } from "src/app/core/interfaces/entity.interface";
import { UUID } from "src/app/core/interfaces";

export namespace EntityDetails {
  export class Reset {
    static readonly type = "[EntityDetails] Reset";
  }

  export class Get {
    static readonly type = "[EntityDetails] Get";
    constructor(public entityId: UUID) {}
  }

  export class Set {
    static readonly type = "[EntityDetails] Set";
    constructor(
      public entityId: UUID,
      public entityDetails: IEntityDetails
    ) {}
  }

  export class SetState {
    static readonly type = "[EntityDetails] SetState";
    constructor(
      public entityId: UUID,
      public entityDetails: IEntityDetails
    ) {}
  }

  export class RemoveOwner {
    static readonly type = "[EntityDetails] Remove Owner";
    constructor(public entityId: UUID, public ownerId: UUID) {}
  }
  export class UpdateAuditLog {
    static readonly type = "[EntityDetails] Update Audit Log";
    constructor(public entityId: UUID, public auditLog: IAuditLog) {}
  }
  export class UpdateOwnerAuditLog {
    static readonly type = "[EntityDetails] Update Owner Audit Log";
    constructor(public ownerId: UUID, public auditLog: IAuditLog) {}
  }

  export class UpdateWithEntityTransfer {
    static readonly type = "[EntityDetails] Update With Entity Transfer"
    constructor(public transferredEntity: IEntity) { }
  }
  export class UpdateWithEntityTransferSuccess {
    static readonly type = "[EntityDetails] Update With Entity Transfer Success"
    constructor(public updatedEntityDetails: IEntityDetails) { }
  }
  export class UpdateWithEntityTransferFail {
    static readonly type = "[EntityDetails] Update With Entity Transfer Fail"
    constructor(public error: unknown) { }
  }

  export class UpdateWithInstantEntityTransfer {
    static readonly type = "[EntityDetails] Update With Instant Entity Transfer"
    constructor(public transferredEntity: IEntity) { }
  }
  export class UpdateWithInstantEntityTransferSuccess {
    static readonly type = "[EntityDetails] Update With Instant Entity Transfer Success"
    constructor(public updatedEntityDetails: IEntityDetails) { }
  }
  export class UpdateWithInstantEntityTransferFail {
    static readonly type = "[EntityDetails] Update With Instant Entity Transfer Fail"
    constructor(public error: unknown) { }
  }
}
